import { render, staticRenderFns } from "./out-of-stock.vue?vue&type=template&id=2c8c923c&scoped=true"
import script from "./out-of-stock.vue?vue&type=script&lang=js"
export * from "./out-of-stock.vue?vue&type=script&lang=js"
import style0 from "./out-of-stock.vue?vue&type=style&index=0&id=2c8c923c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c923c",
  null
  
)

export default component.exports